import { SparklesIcon } from 'lucide-react'

import { IconButton } from '../../../core'
import { GlobalHotkeys } from '../../utils/hotkeys'
import { useHasUserCapability } from '../../hooks/useHasUserCapability'
import { useAskAi } from './AskAiContext'

export function AskAiNavbarButton() {
  const askAi = useAskAi()
  const canAccessAgent = useHasUserCapability('agent')

  if (canAccessAgent === false) {
    return null
  }

  return (
    <div className="hit-area-2 relative -mr-2">
      <IconButton
        size="sm"
        variant="ghost"
        isSelected={askAi.state.isOpen}
        tooltip={{
          content: `Ask AI`,
          hotkey: GlobalHotkeys.askAiDirect,
        }}
        onClick={() => {
          askAi.actions.askQuestion(null)
        }}
      >
        <SparklesIcon />
      </IconButton>
    </div>
  )
}
